<template>
    <!-- 编辑/修改 需求文档 -->
    <el-dialog
            width="45%"
            :visible.sync="show"
            title="修改/编辑开发文档">

        <el-form ref="modifyForm" :rules="rules" :model="formData">
            <el-form-item prop="title" label="标题:" size="mini">
                <el-input
                        type="textarea"
                        placeholder="请输入标题"
                        maxlength="32"
                        :autosize="{ minRows: 2, maxRows: 3}"
                        v-model="formData.title"
                        show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item prop="content" label="详细内容:" size="mini">
                <el-input
                        type="textarea"
                        placeholder="请输入详细内容"
                        maxlength="128"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        v-model="formData.content"
                        show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item label="优先级:" size="mini">
                <el-rate style="padding: 3px 0" v-model="formData.level"></el-rate>
            </el-form-item>
            <el-form-item label="状态变更:" size="mini">
                <el-select v-model="formData.status">
                    <el-option :value="value" :label="label" :key="value" v-for="{value,label} in statusOptions">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button :loading="updateLoading" @click="updateClick" type="primary" size="mini">更 新</el-button>
            <el-button size="mini" @click="close">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapMutations} from 'vuex'

    export default {
        name: "ModifyProReq",
        data() {
            return {
                show: false,
                updateLoading: false,

                statusOptions: [
                    {
                        value: 2,
                        label: '进行中',
                    },
                    {
                        value: 1,
                        label: '已完成',
                    },
                    {
                        value: -1,
                        label: '废弃',
                    },
                ],

                formData: {
                    title: '',
                    content: '',
                    level: 3,
                    status: 2,
                },

                currentProRequirementId: '',

                rules: {
                    title: [
                        {required: true, message: '请输入需求标题', trigger: 'blur'},
                        {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
                    ],
                },
            }
        },
        computed: {
            /**
             * 当前更新对话框组件对象
             */
            modifyForm() {
                return this.$refs.modifyForm
            },
        },
        methods: {
            /**
             * 点击更新
             */
            updateClick() {
                this.modifyForm.validate((validateResult) => {
                    if (validateResult) { // 表单验证通过
                        this._sendUpdateRequest()
                    }
                })
            },

            /**
             *
             */
            _sendUpdateRequest() {
                this.updateLoading = true
                const changeUrl = `${this.$const.proRequirementUrl}${this.currentProRequirementId}/change/`
                this.$patchRequest(changeUrl, this.formData)
                    .then(response => {
                        this.addProRequirements([response.data])
                        this.updateLoading = false
                        this.close()
                        this.$message({
                            type:'success',
                            showClose:true,
                            message:'更新完成'
                        })
                    })
                    .catch(() => {
                        this.updateLoading = false
                    })
            },

            /**
             * 打开对话框
             * @param {Object} proRequirement 产品信息
             */
            open(proRequirement) {
                this.show = true
                for (let key in this.formData) {
                    this.formData[key] = proRequirement[key]
                }
                this.currentProRequirementId = proRequirement.id
            },

            close() {
                this.show = false
            },

            ...mapMutations(['addProRequirements'])
        },
    }
</script>

<style scoped>

</style>